import http from '../utils/request'

export function getCancelInfo(id){
    return http({
        url:'/loan/untie/untieMessage?applyId='+ id,
        method:'get',
    })
}